import { render, staticRenderFns } from "./DropdownGradient.vue?vue&type=template&id=0f3a07c8&"
import script from "./DropdownGradient.vue?vue&type=script&lang=js&"
export * from "./DropdownGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports